import ErrorBox from '@components/common/ErrorBox';
import Button from '@ui/button/Button';
import DwFormField from '@ui/formfield/DwFormField';
import api from '@utils/api';
import formutils from '@utils/formutils';
import createDecorator from 'final-form-focus';
import React, { useEffect, useRef, useState } from 'react';
import { Form } from 'react-final-form';
import ReCAPTCHA from 'react-google-recaptcha';
import { useTranslation } from 'react-i18next';
import analytics from '@utils/analytics';
import { autoChooseClassnames } from '@common/utils/brandDiffsUtils';
import cookie from 'react-cookies';
const focusOnError = createDecorator(); // must be outside the component
const LoginEmailForm = (props) => {
    const { t } = useTranslation();
    const [errors, setErrors] = useState([]);
    const [formdef, setFormdef] = useState();
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [notValidClothing, setNotValidClothing] = useState(false);
    const [initialValues, setInitialValues] = useState();
    const reCaptchaRef = useRef();
    const showRecaptcha = window.recapchaCfg && JSON.parse(window.recapchaCfg).loginButton;
    const searchParams = new URLSearchParams(window.location.search);
    let loginAbandonedCartSubtitle = searchParams.get('abandonedcart') == 'true' ? t('login.abandonedcart.subtitle') : null;
    const toWishlistTitle = searchParams.get('towishlist') == 'true' ? t('login.wishlist.subtitle') : null;
    useEffect(() => {
        let val = {};
        api.getForm('email', val).then((data) => {
            setInitialValues(val);
            setFormdef(data);
        });
    }, []);
    useEffect(() => {
        if (props.profileForm) {
            try {
                const profileForm = JSON.parse(props.profileForm);
                const email = profileForm.customer.email.htmlValue;
                console.log('email', email);
                if (email) {
                    setInitialValues({ email: email });
                }
            }
            catch (e) {
                console.error(e);
            }
        }
    }, [props.profileForm, formdef]);
    const validate = async (values) => {
        return await formutils.validateForm(values, formdef, 'email');
    };
    const onSubmitEmail = async (values) => {
        setErrors([]);
        // Sent to BE information to redirect the user to the wishlist if he comes from it
        if (window.location.href.includes('wishlist')) {
            cookie.save('fromWishlist', 'true', { path: '/', maxAge: 600 });
        }
        else {
            cookie.remove('fromWishlist');
        }
        setIsSubmitting(true);
        if (showRecaptcha) {
            const token = await reCaptchaRef.current.executeAsync();
            values.gr3Token = token;
        }
        api
            .checkLogin(values)
            .then((data) => {
            setIsSubmitting(false);
            // analytics.login();
            props.analyticsKey === 'earlyAccess' && analytics[props.analyticsKey]('pop-up', 'login or register');
            props.analyticsKey === 'menu' && analytics.loginOrRegister('menu');
            props.analyticsKey === 'modal' && analytics.popupLogin();
            props.setDoubleOptIn && props.setDoubleOptIn(data.clothingOptIn);
            if (data.success) {
                props.setLoginEmail(values.email);
                props.isLoginOrRegisterPage && analytics.loginOrRegister('');
                // gestione clothing
                if (window.isClothing) {
                    if (data.clothingEnabled) {
                        setNotValidClothing(false);
                    }
                    else {
                        setNotValidClothing(true);
                        setErrors([t('error.clothingnotavailable')]);
                        return;
                    }
                }
                if (data.exist && data.hasAvailableLoginMethods && !data.isCreationOnBehalfIncomplete) {
                    // check se la privacy policy è stata accettata dall'utente
                    if (!data.privacy) {
                        setErrors([t('login.error.privacy.notflagged')]);
                    }
                    else {
                        // esiste account con questa mail
                        props.setLoginMethods(data.loginMethods);
                        let emailMethodExist = data.loginMethods.find((loginMethod) => loginMethod.ID == 'email');
                        //check account creato in Store
                        if (data.isCreatedInStore && !data.hasChangedPassword) {
                            if (data.hasSentCompleteProfileEmail) {
                                props.setLoginStep('registeredInStore');
                            }
                            else {
                                props.setLoginStep('registeredInStoreSendEmail');
                            }
                        }
                        else {
                            // Se l'ultimo metodo utilizzato è l'email || su clothing l'utente è registrato con una mail
                            if (data.loginMethods[0].ID == 'email' || (window.isClothing && Boolean(emailMethodExist))) {
                                if (!window.isClothing || data.clothingOptIn) {
                                    props.setLoginStep('password');
                                }
                                else {
                                    props.setLoginStep('doubleOptIn');
                                }
                            }
                            else if (window.isClothing && !emailMethodExist) {
                                // Se l'utente abilitato al clothing è registrato con i social
                                props.setLoginStep('register');
                            }
                            else {
                                props.setLoginStep('social-login');
                            }
                        }
                    }
                }
                else {
                    // NON esiste account con questa mail
                    props.setLoginStep('register');
                }
            }
            if (data.error) {
                setErrors([data.errorMessage]);
            }
        })
            .catch((e) => {
            setErrors([e]);
            setIsSubmitting(false);
        });
    };
    const widhHeading = (__text) => {
        if (!props.useHeading)
            return React.createElement("p", { className: "primary-xs" }, __text);
        return props.useHeading === 'h2' ? React.createElement("h2", null, __text) : React.createElement("h3", null, __text);
    };
    const title = props.customTitle || toWishlistTitle || loginAbandonedCartSubtitle || (window.isClothing && t('login.clothing.subtitle')) || t('login.subtitle');
    if (!formdef) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement(React.Fragment, null,
        widhHeading(title),
        React.createElement(Form, { onSubmit: onSubmitEmail, initialValues: initialValues, decorators: [focusOnError], validate: (values) => validate(values), render: ({ handleSubmit, form, submitting, pristine, values }) => (React.createElement("form", { onSubmit: handleSubmit, className: autoChooseClassnames({
                    MO: 'mt-24',
                }) },
                React.createElement("div", { className: autoChooseClassnames({
                        MO: 'mb-16',
                    }, 'formfields') },
                    React.createElement(DwFormField, { onChange: (e) => {
                            setNotValidClothing(false);
                        }, className: notValidClothing && 'error-input', def: formdef, name: "email", type: "email", autocomplete: "email" }),
                    React.createElement(ErrorBox, { errors: errors })),
                showRecaptcha && React.createElement(ReCAPTCHA, { className: "recaptcha", sitekey: window.atob(window.recapchaData), size: "invisible", ref: reCaptchaRef }),
                React.createElement(Button, { type: "submit", disabled: isSubmitting, className: autoChooseClassnames({
                        ST: 'full button-login-cta',
                    }), cls: ['button--primary'], onClick: () => {
                        props.isLoginOrRegisterPage ? analytics.loginOrRegister('') : '';
                    } }, props.customCtaText || t('login.loginregistertomymoncler')))) })));
};
export default LoginEmailForm;
